// Auto-generated by scripts/sync-blog-guide-dates.cjs — do not edit by hand.
// Re-run via npm start / npm run build after changing guide article content.

/** @type {Record<string, { publishedAt: string, updatedAt: string }>} */
export const BLOG_GUIDE_CONTENT_DATES = {
  "volugraph-capture-guide": {
    "publishedAt": "2026-05-31",
    "updatedAt": "2026-05-31"
  },
  "aerial-footage-to-3d-gaussian-splat": {
    "publishedAt": "2026-05-31",
    "updatedAt": "2026-05-31"
  },
  "e-commerce-products": {
    "publishedAt": "2026-05-31",
    "updatedAt": "2026-05-31"
  }
};
